import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { TokenService } from 'src/app/services/token.service';
import appConstant from '../../../assets/app-text.json';
import { ConfirmationModalComponent } from '../../shared/confirmation-modal/confirmation-modal.component';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

export interface CanComponentDeactivate {
  hasUnSavedChanges(): boolean;
}

@Injectable()
export class DeactivateGuard {
  constructor(
    private bsModal: BsModalService,
    private tokenService: TokenService
  ) {}
  bsModalRef: BsModalRef;

  canDeactivate(
    component: CanComponentDeactivate,
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    if (component.hasUnSavedChanges() && !this.tokenService.isTimedOut) {
      const initialState = {
        Title: appConstant.CONFIRM_TITLE,
        Message: appConstant.CONFIRM_MSG,
        OkBtnText: appConstant.CONFIRM_YES,
        DeclineBtnText: appConstant.CONFIRM_NO,
      };
      
      this.bsModalRef = this.bsModal.show(ConfirmationModalComponent, { initialState });

      return this.bsModalRef.content.confirm.pipe(
        map((result: boolean) => result)
      );
    } else {
      return true;
    }
  }
}
